// third party imports
import React, { useState, useEffect, useContext } from "react";

// internal rebet imports
import "./stylesPayments.css";
import { SIDER_TABS } from "../../utils/Constants";
import Layout from "../CommonComponents/Layout/Layout";

// component imports
import RebetLoader from "../CommonComponents/RebetLoader/RebetLoader";
import DeleteIcon from "../../assets/icons/ic_delete_red.png";

import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import PaymentsInfo from "./PaymentsInfo/PaymentsInfo";
import DeleteRowPopup from "./DeleteRowPopup/DeleteRowPopup";
import { formatNumber } from "chart.js/helpers";
import { Badge, Card, Table } from "antd";
import AppContext from "../../context/AppContext";

// asset imports

const generateFakeData = (count) => {
  return Array.from({ length: count }, (_, i) => ({
    user_id: i + 1,
    transaction_id: i + 1,
    username: `User ${i + 1}`,
    amount: Math.floor(Math.random() * 1000) + 1,
  }));
};

const Payments = () => {
  // non-state variables
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const { setActiveSidebarTab } = useContext(AppContext);


  // state variables
  const [isApiRunning, setIsApiRunning] = useState(false);

  const [paymentsTable, setPaymentsTable] = useState([]);
  const [isDeleteRowPopupVisible, setIsDeleteRowPopupVisible] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [paymentInfo, setPaymentInfo] = useState({
    usersAffected: 2000,
    totalAmount: 100000,
  });
  const [pageSize, setPageSize] = useState(10);

  // api functions
  const getRedemptionsPending = async () => {
    setIsApiRunning(true);
    try {
      const requests = [
        PrivateAdminPanelInstance?.post(API_ROUTES?.REDEMPTIONS_PENDING),
        PrivateAdminPanelInstance?.post(
          API_ROUTES?.TOTAL_PENDING_REDEMPTIONS_AMOUNT
        ),
      ];

      const responses = await Promise.allSettled(requests);

      const [redemptionsPending, totalPendingRedemptionsAmount] = responses;

      if (redemptionsPending.status === "fulfilled") {
        const redemptionsPendingData = redemptionsPending?.value?.data?.data;
        setPaymentsTable(redemptionsPendingData);
      }

      if (totalPendingRedemptionsAmount.status === "fulfilled") {
        const totalPendingRedemptionsAmountData =
          totalPendingRedemptionsAmount?.value?.data?.data;
        setPaymentInfo({
          usersAffected: formatNumber(
            totalPendingRedemptionsAmountData?.total_count
          ),
          totalAmount: formatNumber(
            totalPendingRedemptionsAmountData?.total_amount
          ),
        });
      }
    } catch (error) {
      console.log("error getting payments", error);
    } finally {
      setIsApiRunning(false);
    }
  };

  useEffect(() => {
    getRedemptionsPending();
  }, []);

  useEffect(() => {
    setActiveSidebarTab(SIDER_TABS.PAYMENTS, "Payments");
  }, [setActiveSidebarTab]);

  // table columns
  const columns = [
    {
      title: "ID",
      dataIndex: "user_id",
      key: "user_id",
      render: (user_id, record) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          {record.retry_count > 0 ? (
            <Badge.Ribbon text="Error" color="red">
              <Card
                size="small"
                style={{
                  backgroundColor: "transparent",
                  color: "#FFFFFF",
                  border: "none",
                  padding: "12px 0",
                }}
              >
                <p>{user_id}</p>
              </Card>
            </Badge.Ribbon>
          ) : (
            <p>{user_id}</p>
          )}
        </div>
      ),
    },
    {
      title: "Name",
      dataIndex: "username",
      key: "username",
    },
    {
      title: "Amount ($)",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <img
          className="delete-icon"
          src={DeleteIcon}
          alt="delete icon"
          onClick={() => {
            setSelectedRow(record);
            setIsDeleteRowPopupVisible(true);
          }}
        />
      ),
    },
  ];



  return (
    <Layout>
      <div className="payments-body-container">
        <DeleteRowPopup
          isVisible={isDeleteRowPopupVisible}
          onClosePressed={setIsDeleteRowPopupVisible}
          getRedemptionsPending={getRedemptionsPending}
          selectedRow={selectedRow}
        />
        <div className="payments-table">
          <>
            <div className="head-controls">
              <div className="header-text-container">
                <p className="header-text">Finix Delayed Payment</p>
              </div>
            </div>

            <div className="payments-content-container">
              {isApiRunning ? (
                <RebetLoader height={"100px"} width={"100px"} />
              ) : (
                <>
                  <div className="table-container">
                    <Table
                      dataSource={paymentsTable}
                      columns={columns}
                      pagination={{ pageSize }}
                      onChange={(pagination) => {
                        setPageSize(pagination.pageSize);
                      }}
                    />
                  </div>
                  <PaymentsInfo
                    getRedemptionsPending={getRedemptionsPending}
                    paymentInfo={paymentInfo}
                    apiRunning={isApiRunning}
                  />
                </>
              )}
            </div>
          </>
        </div>
      </div>
    </Layout>
  );
};

export default Payments;
